import React, { useRef, useContext, useState, useEffect } from "react";
import { FaSync, FaPrint, FaPlus } from "react-icons/fa";
import { Button, Box } from "@chakra-ui/react";
import "./student.css"; // Create this file for custom CSS
import List from "./List";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { StudentContext } from "../../Context/StudentContext";
import { useNavigate } from "react-router-dom";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";
import Print_pdf_allstudents from "./Print_pdf_allstudents";
import axios from "axios";
import { BASE_URL } from "../../Globalapi/Globalapi";

const TeacherList = () => {
  const navigate = useNavigate();
  // const { students } = useContext(StudentContext);
  const printRef = useRef();
  const [students, setStudents] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const school_id = sessionStorage.getItem("school_id");
  const fetchStudents = async () => {
    try {
      const jwt = sessionStorage.getItem("jwt");
      const response = await axios.get(
        `${BASE_URL}/admin/student/list_all_student.php?school_id=${school_id}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      setStudents(response.data.data || []);
      setIsDataLoaded(true);
      console.log("studentd list:",response.data.data)
    } catch (error) {
      console.error("Error fetching students:", error);
      setError("Error fetching students");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };

  const handleClick = () => {
    navigate("/students/add"); // Navigate to the desired route
  };

  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Students List</h1>{" "}
          {/* Remove default margin */}
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            {" "}
            {/* Align action buttons to the right */}
            <div className="export-dropdown">
              <Button
                className="export-button"
                display={{ base: "none", md: "flex" }}
                backgroundColor="white"
                fontSize="11px"
                boxShadow="md"
                onClick={handlePrint} // Attach the print handler here
              >
                <FaPrint color="#515B73" />
                Print PDF
              </Button>

              {/* {showPrintPdf && <Print_pdf_allstudents studentData={studentData} />}  */}
            </div>
            <Button
              className="add-teacher-button"
              onClick={handleClick}
              leftIcon={<FaPlus />}
              colorScheme="teal"
            >
              <Box display={{ base: "none", md: "block" }}>Add Student</Box>
            </Button>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Students</span> / <span>All Students</span>
        </Box>
      </div>

      <div id="teacher-list-content">
        <List />
      </div>
      <div style={{ display: "none" }}>
        <Print_pdf_allstudents ref={printComponentRef} students={students} />
      </div>
    </div>
  );
};

export default TeacherList;
